import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { useState } from "react";
import DiscordLoginModal from "./DiscordLoginModal";
import { LogOut, Shield, User as UserIcon } from "lucide-react";

const LOGO_URL =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_roleplay-store-10/artifacts/d28byfwz_ChatGPT%20Image%20Jul%2019%2C%202026%2C%2008_51_14%20AM.png";

const NAV = [
  { label: "Shop", to: "/shop" },
  { label: "Manifesto", to: "/#manifesto" },
  { label: "Account", to: "/account" },
];

export default function Header() {
  const { user, logout } = useAuth();
  const [modalOpen, setModalOpen] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <>
      <header
        data-testid="site-header"
        className="fixed top-0 left-0 right-0 z-50 border-b border-white/5 bg-black/70 backdrop-blur-md"
      >
        <div className="max-w-[1440px] mx-auto flex items-center justify-between px-6 md:px-10 h-16">
          <Link to="/" data-testid="header-logo" className="flex items-center gap-3 group">
            <img src={LOGO_URL} alt="BrokenRP" className="h-9 w-9 object-contain" />
            <div className="leading-none">
              <div className="font-display text-lg tracking-tight text-white group-hover:text-[color:var(--accent-red)] transition-colors">
                BROKEN<span className="text-[color:var(--accent-red)]">RP</span>
              </div>
              <div className="font-mono text-[9px] tracking-[0.28em] text-zinc-500">UK ROLEPLAY / STORE</div>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {NAV.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                data-testid={`nav-${item.label.toLowerCase()}`}
                className={`font-mono text-[11px] tracking-[0.22em] uppercase transition-colors ${
                  pathname === item.to ? "text-white" : "text-zinc-400 hover:text-white"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            {user ? (
              <>
                <div className="hidden sm:flex items-center gap-2 border border-white/10 px-3 h-9">
                  {user.is_admin ? (
                    <Shield className="w-3.5 h-3.5 text-[color:var(--accent-red)]" />
                  ) : (
                    <UserIcon className="w-3.5 h-3.5 text-zinc-400" />
                  )}
                  <span data-testid="header-username" className="font-mono text-[11px] text-white">
                    {user.discord_username || user.email}
                  </span>
                </div>
                {user.is_admin && (
                  <button
                    onClick={() => navigate("/admin")}
                    data-testid="header-admin-btn"
                    className="hidden sm:inline-flex font-mono text-[10px] tracking-[0.24em] uppercase h-9 px-3 border border-white/10 text-white hover:bg-white/5 transition-colors"
                  >
                    Admin
                  </button>
                )}
                <button
                  onClick={() => { logout(); navigate("/"); }}
                  data-testid="header-logout"
                  className="h-9 w-9 flex items-center justify-center border border-white/10 text-zinc-400 hover:text-white hover:border-[color:var(--accent-red)] transition-colors"
                  aria-label="Log out"
                >
                  <LogOut className="w-3.5 h-3.5" />
                </button>
              </>
            ) : (
              <button
                onClick={() => setModalOpen(true)}
                data-testid="header-login-btn"
                className="btn-brutal h-9 px-5 border border-white/15 text-white font-mono text-[10px] tracking-[0.24em] uppercase"
              >
                Login / Discord
              </button>
            )}
          </div>
        </div>
        <div className="uj-bar" />
      </header>
      <DiscordLoginModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}
